import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Platform } from '@ionic/angular';
import { IPlayer, ITeam } from '../../services/lineup-service';
import {CdkDrag, DragDropModule} from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { SvgTshirtContainerComponent } from '../svg-image-container/svg-tshirt-container';

@Component({
  standalone:true,
  selector: 'player-item',
  templateUrl: 'player.html',
  styleUrls:['./player.scss'],
  imports: [CommonModule, CdkDrag, DragDropModule, SvgTshirtContainerComponent],
})
export class PlayerComponent {
  @ViewChild('playerElement') playerElement: ElementRef;

  @Input() bounds: any;
  @Input() player: IPlayer;
  @Input() team: ITeam;

  @Output() onSave = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();
  @Output() onMoving = new EventEmitter<boolean>();

  constructor(private platform: Platform) { }

  // change(event) {
  //   this.onMoving.emit(true);
  //   // this.onChange.emit(event.target);
  // }
  change(event) {
    this.onMoving.emit(true);
  }

  onDropped($event) {
    let coords = this.playerElement.nativeElement.getBoundingClientRect();
    this.player.cX = coords.x;
    this.player.cY = coords.top - 30;
    this.onMoving.emit(false);
    this.onSave.emit(this.player);
  }

  onStarted(event) {
    this.onMoving.emit(true);
    // this.onChange.emit(event.target);
  }

  onTap(event?) {
    console.log('onTap')
    if (!this.platform.is('mobileweb')) { event.stopPropagation(); }
  }
}

// TODO: detect which of the events (tap, click, started) prevents propagation

